// constants.js
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';

/* export const logo = 'https://i.ibb.co/s9Qys2j/logo.png'; */

export const logo = 'https://static.thenounproject.com/png/975435-42.png'; 

{/* This was from index.html - so you could not get folder images to work - so this is probably how you link folder images with %PUBLIC_URL%/logo.png <link rel="icon" href="%PUBLIC_URL%/logo192.png" />  */}


export const categories = [ 
  { name: 'Premier League highlights', icon: <OndemandVideoIcon />, },
  { name: 'La Liga highlights', icon: <OndemandVideoIcon />, },
  { name: 'Bundesliga highlights', icon: <OndemandVideoIcon />, },
  { name: 'Sky Sports News', icon: <OndemandVideoIcon />, }, 
  { name: 'TalkSPORT Radio', icon: <OndemandVideoIcon />, }, 
  { name: 'Goals Comps', icon: <OndemandVideoIcon />, },
  { name: 'Skills Comps', icon: <OndemandVideoIcon />, },
  { name: 'Champions League highlights', icon: <OndemandVideoIcon />, },
  { name: 'Europa League highlights', icon: <OndemandVideoIcon />, }, 
  { name: 'Uefa conference highlights', icon: <OndemandVideoIcon />, }, 
  { name: 'World Cup highlights', icon: <OndemandVideoIcon />, },
  { name: 'Serie A highlights', icon: <OndemandVideoIcon /> }, 
  { name: 'Ligue 1 highlights', icon: <OndemandVideoIcon />, }, 
  { name: 'EA FC Gameplay', icon: <OndemandVideoIcon />, }, 
  { name: 'FIFA Gameplay', icon: <OndemandVideoIcon />, }, 
  { name: 'Euros highlights', icon: <OndemandVideoIcon />, }, 
  { name: 'Copa America highlights', icon: <OndemandVideoIcon />, }, 
  { name: 'AFCON highlights', icon: <OndemandVideoIcon />, }, 
  { name: 'Technical Elegance', icon: <OndemandVideoIcon />, }, 
  { name: 'SPFL Highlights', icon: <OndemandVideoIcon />, }, 
  { name: 'Transfer News', icon: <OndemandVideoIcon />, }, 
];

// CONSTANTS.js
export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCbzAEZdQW4vlHt1Wyqy2Zyw';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'ArsenalComps';
export const demoVideoTitle = 'Arsenal Comps';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png';
